export default "__VITE_ASSET__Cl6KfM2S__"